module.exports = __webpack_public_path__ + "img/banner.1efb58b.jpg";